import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;

  a:hover {
    color: var(--color-primary-dark);
  }
`;

export const StyledLabel = styled.label`
  margin-top: 2em;
  color: rgba(0, 0, 0, 0.87);
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button,
  a {
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }
`;
